<div class="office-assignments">
  <div class="card bg-transparent border-0">
    <div
      class="card-header bg-transparent border-0 d-flex justify-content-between align-items-center mb-4">
      <h5 class="mb-0">Office Assignments</h5>
      <button
        class="btn btn-primary d-flex align-items-center"
        (click)="onAddNew()">
        <i class="fas fa-plus me-2"></i>Add new assignment
      </button>
    </div>

    <div class="row g-4">
      <div *ngFor="let assignment of assignments" class="col-12">
        <div class="card shadow-sm hover-shadow">
          <div class="card-body p-3">
            <div class="d-flex justify-content-between align-items-center">
              <div class="flex-grow-1">
                <p class="mb-2 text-primary">
                  {{ assignment.workflowContext.event }}
                  {{ ' | ' }}
                  <strong>
                    <ng-container [ngSwitch]="assignment.type">
                      <span *ngSwitchCase="'FIXED'">
                        Office ID: {{ assignment.officeId }}
                      </span>
                      <span *ngSwitchCase="'LOCATION_BASED'">
                        Based on field: {{ assignment.formFieldKey }}
                      </span>
                      <span *ngSwitchCase="'MULTIPLE_LOCATION'">
                        Based on fields:
                        {{ assignment.formFieldKeys?.join(', ') }}
                      </span>
                    </ng-container>
                  </strong>
                  {{ ' | ' }}
                  <strong>{{
                    '(' + getAssignmentTypeDisplay(assignment.type) + ')'
                  }}</strong>
                </p>
                <p class="mb-0 text-muted">
                  From
                  <strong>{{ assignment.workflowContext.startState }}</strong>
                  to
                  <strong>{{ assignment.workflowContext.endStateCode }}</strong>
                  <span class="ms-2 badge bg-info">{{
                    getEndStateTypeDisplay(
                      assignment.workflowContext.endStateType
                    )
                  }}</span>
                </p>
                <p class="m-0">
                  <span class="text-muted">Action Type:</span>
                  <span>{{
                    getActionTypeDisplay(assignment.workflowContext.actionType)
                  }}</span>
                </p>
              </div>
              <div class="action-buttons ms-3 d-flex gap-2">
                <button
                  (click)="onEdit(assignment)"
                  class="btn btn-sm btn-icon btn-outline-primary"
                  title="Edit">
                  <i class="fas fa-edit"></i>
                </button>
                <button
                  (click)="onDelete(assignment)"
                  class="btn btn-sm btn-icon btn-outline-danger"
                  title="Delete">
                  <i class="fas fa-trash-alt"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="assignments.length === 0" class="col-12">
        <div class="alert alert-info text-center py-4">
          <i class="fas fa-info-circle me-2"></i>
          No office assignments configured. Click 'Add Template' to begin.
        </div>
      </div>
    </div>
  </div>
</div>
